import { render, staticRenderFns } from "./Competence.vue?vue&type=template&id=72d52be5&scoped=true&"
import script from "./Competence.vue?vue&type=script&lang=js&"
export * from "./Competence.vue?vue&type=script&lang=js&"
import style0 from "./Competence.vue?vue&type=style&index=0&id=72d52be5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d52be5",
  null
  
)

export default component.exports